import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, Modal, Box, Grid,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../styles/MyStyles";
import {GetAssetLookupMenuItemsByType, GetLookupMenuItems} from "../../logic/LookupHelper";
import {CreateDataUpdateTicket} from "../../logic/TicketHelper";

const BankAccountRequestPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showRedirectModal, setShowRedirectModal] = useState(false);

    const [request, setRequest] = useState({
        name: '',
        swift: '',
        address: '',
        countryId: '',
        assetId: '',
        iban: ''
    });

    useEffect(() => {
    }, []);

    const validateForm = () => {
        let newErrors = {};

        if (!request.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        if (!request.swift.trim()) {
            newErrors.swift = 'Swift is required.';
        }

        if (!request.address.trim()) {
            newErrors.address = 'Address is required.';
        }
        if (request.countryId === '') {
            newErrors.countryId = 'Country is required.';
        }

        if (request.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (!request.iban.trim()) {
            newErrors.iban = 'Iabn is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            await CreateDataUpdateTicket(3, request);
            setShowRedirectModal(true);
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleCloseRedirectModal = (redirect) => {
        if (redirect) {
            navigate('/tickets');
        } else {
            handleGoBack()
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                New Wallet Request
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Send request
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Bank Name</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="name"
                                label="Name"
                                value={request.name}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Bank Swift</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="swift"
                                label="Swift"
                                value={request.swift}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.swift}
                                helperText={errors.swift}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Bank Address</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="address"
                                label="Address"
                                value={request.address}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Bank Country</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="countryId"
                                label="Country"
                                select
                                value={request.countryId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.countryId}
                                helperText={errors.countryId}
                            >
                                {GetLookupMenuItems('country')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={request.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetAssetLookupMenuItemsByType(0)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Iban</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="iban"
                                label="Iban"
                                value={request.iban}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.iban}
                                helperText={errors.iban}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {showRedirectModal && (<Modal open={showRedirectModal} onClose={() => handleCloseRedirectModal(true)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        This action creates a new Ticket, the status of which you can see in the Tickets section.
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={12}>
                            <StyledButtonOrange onClick={() => handleCloseRedirectModal(true)}>
                                Ok
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </Container>
    );
};

export default BankAccountRequestPage;
